import { FULL_ACCESS_ACTION_NAMES } from 'widget/ui-selectors/video-access';

import { DEFAULT_TRANSLATIONS as VIDEO_TRANSLATIONS } from 'widget/components/overlay-texts/video/play-button-text';

import commonTranslations from 'shared/translations/overlay-common-translations';


export default function getTranslationData(availableVideoType, fullAccessAction) {
  if (availableVideoType) {
    return {
      props: VIDEO_TRANSLATIONS[availableVideoType],
    };
  } else if (fullAccessAction === FULL_ACCESS_ACTION_NAMES.SIGN_IN) {
    return {
      props: commonTranslations.playVideo,
    };
  }

  return null;
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/player-overlay/ui-selectors/video-overlay/play/translation-data.js